/**
 * Strings for the email verification feature.
 *
 * Namespace: verifyEmail
 */
export const verifyEmail = {
  // Page
  page: {
    title: "Email cím megerősítése",
    subtitle: "Kérjük, várjon, amíg megerősítjük az email címét",
  },

  // Success
  success: {
    title: "Email cím megerősítve!",
    message: "Az email címe sikeresen megerősítésre került. Most már bejelentkezhet a fiókjába.",
    goToLogin: "Tovább a bejelentkezéshez",
  },

  // Errors
  errors: {
    invalidToken: "Az email megerősítő link érvénytelen vagy lejárt.",
  },

  // Processing state
  processing: {
    title: "Email cím megerősítése...",
    subtitle: "Kérjük, várjon egy pillanatot",
  },
} as const;

export type VerifyEmailMessages = typeof verifyEmail;
